import { render, staticRenderFns } from "./LocationCatalogues.vue?vue&type=template&id=0d3c1dbe&scoped=true&"
import script from "./LocationCatalogues.vue?vue&type=script&lang=ts&"
export * from "./LocationCatalogues.vue?vue&type=script&lang=ts&"
import style0 from "./LocationCatalogues.vue?vue&type=style&index=0&id=0d3c1dbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3c1dbe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d3c1dbe')) {
      api.createRecord('0d3c1dbe', component.options)
    } else {
      api.reload('0d3c1dbe', component.options)
    }
    module.hot.accept("./LocationCatalogues.vue?vue&type=template&id=0d3c1dbe&scoped=true&", function () {
      api.rerender('0d3c1dbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Brand/LocationCatalogues.vue"
export default component.exports